export default __webpack_public_path__ + "static/media/PERFIL_INVERSIONISTA.25b08c7e.png";